module.exports = __webpack_public_path__ + "img/153.5b2b1c4e.png";